<template>
  <v-dialog :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <div class="pa-4">
        <label class="label-input">Section Name</label>
        <v-text-field v-model="fields['title']" />
        <div class="mb-5">
          <div class="label-input">Layout</div>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Background Section</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['card-container']"
                    @change="handleChangeCardContainer"
                  />
                  <v-text-field v-model="fields['card-container']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['text-color']"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['text-color']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <label>Media Position</label>
                <v-select
                  :value="fields['card-item-image']"
                  :items="positionOptions"
                  :hide-details="true"
                  class="mt-0"
                  @change="handleChangePosition"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-checkbox v-model="fields['top-padding']" label="Padding top" :hide-details="true" class="mb-2" />
                <v-checkbox
                  v-model="fields['bottom-padding']"
                  label="Padding bottom"
                  :hide-details="true"
                  class="mb-2"
                />
                <v-checkbox
                  v-model="fields['style-center-y']"
                  label="Style center Y"
                  :hide-details="true"
                  class="mb-2"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="label-input">Container</div>
          <div class="group-item">
            <v-row class="mb-0">
              <v-col cols="12" md="6">
                <v-checkbox
                  v-model="fields['container-page']['show-style']"
                  label="Show Style Container"
                  :hide-details="true"
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['container-page']['background']"
                    @change="handleChangeContainerBackground"
                  />
                  <v-text-field v-model="fields['container-page']['background']" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-4">
          <label class="label-input">Card Content</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields['card-title']" :config="editorConfig" />
            <div class="mt-4">
              <v-checkbox
                v-model="fields['highlight-text']['show']"
                label="Show highlight text"
                :hide-details="true"
                class="mb-2 mt-0"
              />
              <v-text-field v-model="fields['highlight-text']['content']" :hide-details="true" class="mt-0" />
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label for="card-survay" style="margin-bottom: 0; margin-right: 10px;" class="label-input">Survey</label>
            <input id="card-survay" type="checkbox" v-model="fields['card-survay']" />
          </div>
          <div class="group-item">
            <div>
              <label>Survey Percent Color</label>
              <div class="d-flex align-center gap-3 mb-3">
                <input
                  type="color"
                  style="width: 40px; height: 40px; margin-right: 12px"
                  :value="fields['color-percent-survay']"
                  @change="handleChangeColorPercent"
                />
                <v-text-field v-model="fields['color-percent-survay']" :hide-details="true" class="mt-0" />
              </div>
            </div>
            <div>
              <div class="d-flex justify-space-between align-center mb-2">
                <div></div>
                <v-btn small text color="primary" @click="handleAddSurvey">
                  <v-icon size="16">mdi-plus</v-icon>
                  <span> Add Survey Item</span>
                </v-btn>
              </div>
              <v-expansion-panels accordion>
                <v-expansion-panel v-for="(item, index) in fields['items-survay']" :key="index">
                  <v-expansion-panel-header>
                    <div class="d-flex align-center gap-3 justify-space-between">
                      <div>Survey {{ index + 1 }}</div>
                      <v-btn
                        icon
                        color="error"
                        @click="handleRemoveSurvey(index)"
                        :disabled="fields['items-survay'].length <= 1"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div>
                      <label>Percent</label>
                      <v-text-field v-model.number="item.percent" type="number" min="0" max="100" />
                    </div>
                    <div>
                      <label>Description</label>
                      <!-- <v-text-field v-model="item.description" /> -->
                      <ckeditor :editor="editor" v-model="item.description" :config="editorConfig" />
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex align-center mb-2">
            <label for="card-button" style="margin-bottom: 0; margin-right: 10px;" class="label-input">Button</label>
            <input id="card-button" type="checkbox" v-model="fields['button']['show']" />
          </div>
          <div class="group-item">
            <div>
              <label>Button Text</label>
              <v-text-field v-model="fields.button.text" :hide-details="true" class="mt-0" />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Link</label>
                <v-text-field v-model="fields.button.link" :hide-details="true" class="mt-0" />
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Radius</label>
                <v-text-field type="number" v-model="fields.button.radius" :hide-details="true" class="mt-0" />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <label>Button Background</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.background"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields.button.background" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <label>Button Text Color</label>
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="handleChangeButtonColor"
                  />
                  <v-text-field v-model="fields.button.color" :hide-details="true" class="mt-0" />
                </div>
              </v-col>
            </v-row>
            <div>
              <label>Sub Button</label>
              <v-text-field v-model="fields['sub-btn']" :hide-details="true" class="mt-0" />
            </div>
          </div>
        </div>

        <div class="">
          <div class="label-input">Media</div>
          <div class="group-item">
            <div>
              <v-radio-group
                row
                dense
                :value="fields.media['show-image'] ? 'image' : 'video'"
                @change="val => handleChangeMediaType(val)"
              >
                <v-radio small label="Image" value="image" />
                <v-radio small label="Video" value="video" />
              </v-radio-group>
            </div>
            <div v-if="fields.media['show-image']">
              <UploadImage
                @callback="handleUploadImage"
                :image="{ imageSrc: fields.media.image }"
                :height="`220`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveUpload"
              />
            </div>
            <div v-if="fields.media['show-video']">
              <div>
                <div>Video URL</div>
                <div class="d-flex align-center gap-6 mb-2">
                  <v-text-field v-model="fields.media.video" :hide-details="true" class="mt-0" />
                  <v-btn @click="handlePreviewVideo" text color="primary"> <v-icon>mdi-reload</v-icon> Reload </v-btn>
                </div>
              </div>
              <div class="video-wrapper">
                <div class="wrap-video">
                  <video width="100%" height="auto" autoplay muted loop playsinline ref="videoPlayer">
                    <source type="video/mp4" :src="fields.media.video" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import { updateHtmlFromData } from '../common/html/update';

export default {
  name: 'CardKynorelle',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: [
        { text: 'Left', value: 1 },
        { text: 'Right', value: 2 },
      ],
      fields: {
        title: 'Card Kynorelle Section',
        'card-container': '#FFFFFF',
        'text-color': '#000000',
        'top-padding': false,
        'bottom-padding': false,
        'container-page': {
          'show-style': false,
          background: '#FFFFFF',
        },
        'card-item-content': 1,
        'card-item-image': 2,
        'style-center-y': false,
        'card-title': '',
        'card-description': '',
        'highlight-text': {
          show: true,
          content: '',
        },
        'card-survay': true,
        'color-percent-survay': '#606F99',
        'items-survay': [{ percent: 0, description: '' }],
        button: {
          show: true,
          text: '',
          link: '#',
          background: '#F35C5C',
          color: '#ffffff',
          radius: '0',
        },
        'sub-btn': '',
        media: {
          'show-image': true,
          image: '',
          'show-video': true,
          video: '',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
      'container-page': {
        ...this.fields['container-page'],
        ...(this.sectionEditor.sectionExtract['container-page'] || {}),
      },
      'highlight-text': {
        ...this.fields['highlight-text'],
        ...(this.sectionEditor.sectionExtract['highlight-text'] || {}),
      },
      button: {
        ...this.fields.button,
        ...(this.sectionEditor.sectionExtract.button || {}),
      },
      media: {
        ...this.fields.media,
        ...(this.sectionEditor.sectionExtract.media || {}),
      },
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardKynorelle(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handlePreviewVideo() {
      const video = this.$refs.videoPlayer;
      if (!video) return;
      video.load();
      video.play();
    },
    handleChangeMediaType(type) {
      const isImage = type === 'image';
      this.fields.media['show-image'] = isImage;
      this.fields.media['show-video'] = !isImage;
      this.fields.media.video = '';
      this.fields.media.image = '';
    },
    handleChangePosition(value) {
      this.fields['card-item-image'] = Number(value);
      this.fields['card-item-content'] = Number(value) === 1 ? 2 : 1;
    },
    handleAddSurvey() {
      this.fields['items-survay'].push({
        percent: 0,
        description: '',
      });
    },
    handleRemoveSurvey(index) {
      if (this.fields['items-survay'].length <= 1) return;
      this.fields['items-survay'].splice(index, 1);
    },
    handleUploadImage(obj) {
      const url = obj.imageSrc;
      try {
        const u = new URL(url);
        const pathMatch = u.pathname.match(/\/images\/(.+)/);
        let newPath = pathMatch ? `/uploads/images/${pathMatch[1]}` : url;
        const q = u.searchParams.get('q');
        if (q) {
          newPath += `?w=1000&q=100`;
        }
        const isDev = process.env.NODE_ENV === 'development';
        this.fields.media.image = isDev ? url : newPath;
      } catch (e) {
        this.fields.media.image = url;
      }
    },
    handleRemoveUpload() {
      this.fields.media.image = '';
    },
    handleChangeCardContainer(event) {
      this.fields['card-container'] = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields['text-color'] = event.target.value;
    },
    handleChangeContainerBackground(event) {
      this.fields['container-page'].background = event.target.value;
    },
    handleChangeColorPercent(event) {
      this.fields['color-percent-survay'] = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields.button.background = event.target.value;
    },
    handleChangeButtonColor(event) {
      this.fields.button.color = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.wrap-title-card {
  ::v-deep(.ck-editor__editable_inline) {
    min-height: 140px;
  }
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.survey-item {
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 10px 12px 0;
  margin-bottom: 12px;
}
.video-wrapper {
  background: rgba(0, 0, 0, 0.767);
  .wrap-video {
    max-width: 500px;
    margin: 0 auto;
    video {
      display: block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
